<template>
    <div>
        <v-text-field type="text" v-bind:class='showClass' :color="color" :label="label" v-model="displayValue" @blur="on_blur" @focus="isInputActive = true" :readonly="readonly" :disabled="disabled === true || disabled === 1" @keyup.enter="press_enter"/>
    </div>
</template>
<script>
export default {
    name: 'h-currency-input',
    props: ["value", "label", "disabled", "decimal", "showClass", "readonly", "color"],
    data: function() {
        return {
            isInputActive: false
        }
    },
    computed: {
        displayValue: {
            get: function() {
                if (this.isInputActive) {
                    // Cursor is inside the input field. unformat display value for user
                    return (this.value || '').toString()
                } else {
                    // User is not modifying now. Format display value for user interface
                    var parseValue = Number(this.value)
                    return this.value ? parseValue.toFixed(this.decimal !== undefined ? this.decimal : 2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,") : '0'
                }
            },
            set: function(modifiedValue) {
                // Recalculate value after ignoring "$" and "," in user input
                let newValue = parseFloat(modifiedValue.replace(/[^\d\.]/g, ""))
                // Ensure that it is not NaN
                if (isNaN(newValue)) {
                    newValue = 0
                }
                // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
                // $emit the event so that parent component gets it
                this.$emit('input', newValue)
            }
        }
    },
    methods: {
        press_enter() {
            this.$emit('press_enter')
        },
        on_blur() {
            this.isInputActive = false;
            this.$emit('on_blur')
        }
    }
}
</script>
